export default {
  data() {
    return {
      markAsProcessed: true
    }
  },
  methods: {
    markEmailComplete(options = {}) {
      if (this.markAsProcessed) {
        const { markEmailAsComplete } = require('../service/Actions')
        const {
          message = 'Follow up. Email has been processed'
        } = options

        markEmailAsComplete(
          'completeNotification',
          message,
          'Icon.16x16',
          true
        )
      }
    }
  }
}